import React, { Component } from 'react';
import {
    Form, Input, Button, Select, Modal, InputNumber, DatePicker,
} from 'antd';
import moment from 'moment';
import 'antd/dist/antd.css';

const { RangePicker } = DatePicker;
const Option = Select.Option;

function handleChange(value) {
    console.log(`selected ${value}`);
}

function handleBlur() {
    console.log('blur');
}

function handleFocus() {
    console.log('focus');
}

class MachineTimersAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    onChange(date, dateString) {
        console.log(date, dateString);
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(e);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
                this.props.form.resetFields();
            }
        });
    }

    disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { timer } = this.props;
        return (
            <div>
                <Modal
                    title="Manejo de Timer"
                    visible={this.props.openForm}
                    onOk={this.handleOk}
                    onCancel={this.props.onCancel}
                    footer={null}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item
                            {...formItemLayout}
                            label="Nombre"
                        >
                            {getFieldDecorator('name', {
                                initialValue: (timer != null) ? timer.cost : '',
                                rules: [{ required: true, message: 'Ingrese el nombre del timer' }],
                            })(
                                <Input />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Descripción"
                        >
                            {getFieldDecorator('description', {
                                initialValue: (timer != null) ? timer.description : '',
                                rules: [{ required: true, message: 'Ingrese una descripción' }],
                            })(
                                <Input.TextArea rows={4} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Próximo Servicio"
                        >
                            {getFieldDecorator('service', {
                                initialValue: (timer) ? moment(timer.service) : '',
                                rules: [{ required: true }],
                            })(
                                <RangePicker onChange={this.onChange} disabledDate={this.disabledDate} />,
                            )}
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" onClick={this.handleOk}>
                                Guardar
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(MachineTimersAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineTimersAddView.js